import React from 'react';
import PropTypes from 'prop-types';
import styles from './Navigation.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import scrollToElement from '../../../../services/smooth_scroll';

function Navigation(props) {
  const { sections: sectionsFromProps, className } = props;

  const sections = sectionsFromProps.filter((section) => document.getElementById(section.url));

  if (sections.length === 0) { return null; }

  return (
    <div className={`${styles.navigation} ${className}`}>
      <div className={styles.sections}>
        {sections.map((section) => (
          <ClickableDiv
            key={section.url}
            className={styles.section}
            onClick={() => { scrollToElement(section.url); }}
          >
            {section.name}
          </ClickableDiv>
        ))}
      </div>
    </div>
  );
}

Navigation.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  className: PropTypes.string,
};

export default Navigation;
